export const camposPerfilTributarioProduto = [
  "id_cst_csosn",
  "id_cst_csosn_contribuinte",
  "id_cfop",
  "id_cfop_nfce",
  "id_cest",
  "id_ncm",
  "id_cstipi",
  "id_cstpis",
  "id_cstcofins",
  "id_cenq",
  "id_tributacao",
  "id_tributacao_st",
  "id_fcp",
  "ipi",
  "pis",
  "cofins",
  "mva",
  "codigo_beneficio",
  "excecaoFiscal",
  "class_trib_ibs_cbs",
  "cst_ibs_cbs",
  "class_trib_regular",
  "cst_regular",
  "cod_cred_presumido",
  "ind_bem_movel_usado",
  "ibs_diferimento_mun",
  "ibs_reducao_mun",
  "ibs_reducao_uf",
  "ibs_diferimento_uf",
  "ibs_aliq_cred_presumido",
  "cbs_diferimento",
  "cbs_reducao",
  "cbs_aliq_cred_presumido",
  "cst_is",
  "class_trib_is",
  "aliquota_is",
  "aliquota_especifica_is",
  "ibs_aliquota_efetiva_mu",
  "ibs_aliquota_efetiva_uf",
];

export function aplicarValoresPerfilTributario(
  form,
  perfilTributario,
  deveAplicarCampo
) {
  if (!perfilTributario || !perfilTributario.id) return;

  camposPerfilTributarioProduto.forEach((field) => {
    if (field !== "id_ncm" && deveAplicarCampo(field)) {
      form[field] = perfilTributario[field];
    }
  });
}
